const Backbone = require('lib/backbone')
const _ = require('lib/underscore')
const BaseModel = require('lib/base_model')
const ElementList = require('./element_list')
const log = require('log').create('freeform', 'form') // eslint-disable-line


const Form = BaseModel.extend({

    defaults: {
        display_errors: true,
        error_class: 'error glyph-attention',
        display_confirmations: true,
        confirmation_class: 'confirmation glyph-confirmation',
        display_note: true,
        note_class: 'note',
        submitting: false,
    },

     
    constructor: function constructor(attrs = {}, options = {}) {
        this.setupElements(attrs)

        Backbone.Model.apply(this, [attrs, options])

        this.listenTo(this, 'change:related_model', this.onChangeRelatedModel)
    },

    setupElements(attrs) {
        // if elements is an array
        // convert it to an ElementList, passing the related model, if defined
        if (_.isArray(attrs.elements)) {
            attrs.elements = new ElementList(attrs.elements)
        }

        // ensure that elements is an ElementList
        if (! (attrs.elements instanceof ElementList)) {
            throw new Error('Form.elements must be an array or an ElementList')
        }

        if (attrs.related_model) {
            attrs.elements.setRelatedModel(attrs.related_model)
        }

        return attrs
    },

    onChangeRelatedModel(model, related_model, options) {
        this.get('elements').setRelatedModel(related_model)
    },

    validators: {
        'elements': function elementsValidator(elements) {
            let error

            // validate with model validator
            const validator = this.get('validator')
            if (_.isFunction(validator)) {
                error = validator.call(this)
            }
            // if custom validator returns an error, return that
            if (error) return error

            // loop through elements and return the first error
            elements.each((element) => {
                if (error) return
                element.validateElement()
                if (element.validationError) error = element.validationError
            })
            // return first element validation error, if any exists
            if (error) return error
        },
    },
})

module.exports = Form
